module.exports = __webpack_public_path__ + "9f365a02e80c96b1dcc3b95aec61e09b.png";


//////////////////
// WEBPACK FOOTER
// ./src/global/images/arrow.png
// module id = xqM7
// module chunks = 0